export const lightFontWeight = 400;
export const regularFontWeight = 500;
export const boldFontWeight = 600;
export const heavyFontWeight = 700;

export const white = "#FFF";
export const black = "#333333";

export const green = "#1C8567"; // Standardgrön
export const darkGreen = "#107055"; // Mörkare grön
export const lightGreen = "#2DAF85"; // Ljusare grön

export const blue = "#0073E6"; // Standardblå (liknande "Royal Blue")
export const darkBlue = "#005BB5"; // Mörkare blå
export const lightBlue = "#3399FF"; // Ljusare blå

export const red = "#CC0000"; // Standardröd
export const darkRed = "#990000"; // Mörkare röd
export const lightRed = "#FF4D4D"; // Ljusare röd

export const lightGrey = "#FAFAFA"; // Ljusgrå
export const grey = "#DBDBDB"; // Standardgrå
export const mediumGrey = "#F4F4F4"; // Mellangrå
export const darkGrey = "#737373"; // Mörkgrå
export const orange = "#F39C12";
export const yellow = "#FFC107";

export const spacing = {
  xxxxl: "70px",
  xxxl: "40px",
  xxl: "32px",
  xl: "24px",
  l: "20px",
  m: "16px",
  s: "12px",
  xs: "8px",
  xxs: "4px",
};
export const fontSize = {
  hero: "48px",
  xxl: "32px",
  xl: "24px",
  l: "20px",
  ml: "18px",
  m: "16px",
  s: "14px",
  xs: "12px",
  xxs: "10px",
};
export const fontWeight = {
  light: lightFontWeight,
  regular: regularFontWeight,
  bold: boldFontWeight,
  heavy: heavyFontWeight,
};

export enum Theme {
  Primary = "primary",
  Secondary = "secondary",
  Monochrome = "monochrome",
  Positive = "positive",
  Negative = "negative",
  Transparent = "transparent",
  Disabled = "disabled",
  Dark = "dark",
}

export enum Size {
  Small = "small",
  Medium = "medium",
  Large = "large",
}

type ThemeType = {
  backgroundColor: string;
  hover: string; // Tvingar alla att ha hover
  color: string;
};

export const size = {
  small: { x: spacing.s, y: spacing.s },
  medium: { x: spacing.s, y: "18px" },
  large: { x: spacing.xl, y: spacing.xxl },
};

export const theme: Record<string, ThemeType> = {
  primary: {
    backgroundColor: green,
    hover: darkGreen,
    color: white,
  },
  secondary: {
    backgroundColor: blue,
    hover: darkBlue,
    color: white,
  },
  monochrome: {
    backgroundColor: grey,
    hover: darkGrey,
    color: black,
  },
  positive: {
    backgroundColor: green,
    hover: darkGreen,
    color: white,
  },
  negative: {
    backgroundColor: red,
    hover: darkRed,
    color: white,
  },
  transparent: {
    backgroundColor: "rgba(125, 125, 125, 0)",
    hover: "rgba(125, 125, 125, .25)",
    color: "inherit",
  },
  dark: {
    backgroundColor: black,
    hover: darkGrey,
    color: white,
  },
  disabled: {
    backgroundColor: grey,
    hover: grey,
    color: darkGrey,
  },
};

export type Themes = typeof theme;
